import httpClient from "@/plugins/axios";

export const updateTenantLogo = async (file) => {
    const formData = new FormData();
    formData.append('logo', file, file.name);

    const response = await httpClient.put(`/admin/v1/tenant/logo/`, formData);
    return response;
}
